
<div class="eye-view-consignor mb-4">
  <div class="row eye-view-consignor-row">
    <div class="col-4 mogo-bold text-end eye-view-consignor-header">
      Consignor
    </div>
    <div class="col-8 eye-view-consignor-content">
      {{ consignorDetails.consignorName}}
    </div>
  </div>
  <div class="row eye-view-consignor-row">
    <div class="col-4 mogo-bold text-end eye-view-consignor-header">
      Address
    </div>
    <div class="col-8 eye-view-consignor-content">
      {{ consignorDetails.consignorAddress}}
    </div>
  </div>
  <div class="row ">
    <div class="col-4 mogo-bold text-end eye-view-consignor-header">
      Warehouse Created Date
    </div>
    <div class="col-8 eye-view-consignor-content">
      {{  consignorDetails.warehouseCreatedDate | date: 'dd/MM/yyyy'}}
    </div>
  </div>
</div>
